import React from "react";

import Message from "@JohnLewisPartnership/jlfs-ui-library/dist/components/message/message";

const MapUnavailableMessage: React.FC = () => {
  return (
    <Message
      title="Unable to load store map. Please update your browser to Safari 14 or newer."
      type="warning"
    >
      Our store map shows the stores closest to you.
    </Message>
  );
};

export default MapUnavailableMessage;
